﻿<template>
    <q-separator color="white q-mt-sm q-mb-sm" />
</template>

<script setup lang="ts">
</script>
